(function () {
  function formatRemaining(ms) {
    if (ms <= 0) {
      return null;
    }

    var totalMinutes = Math.floor(ms / 60000);
    var totalHours = Math.floor(ms / 3600000);
    var totalDays = Math.floor(ms / 86400000);

    if (totalDays >= 1) {
      return totalDays + (totalDays === 1 ? " Day" : " Days");
    }

    if (totalHours >= 1) {
      return String(totalHours).padStart(2, "0") + " Hours";
    }

    return String(Math.max(totalMinutes, 1)).padStart(2, "0") + " Minutes";
  }

  function initCountdown(root) {
    root.querySelectorAll("[data-ssh-countdown]").forEach(function (timer) {
      if (timer.dataset.sshCountdownBound === "true") {
        return;
      }

      var endValue = timer.dataset.end;
      var end = endValue ? new Date(endValue).getTime() : NaN;
      if (Number.isNaN(end)) {
        return;
      }

      timer.dataset.sshCountdownBound = "true";

      var label = timer.querySelector("[data-ssh-countdown-label]");
      var value = timer.querySelector("[data-ssh-countdown-value]");
      var prefix = timer.dataset.prefix || "";
      var expired = timer.dataset.expired || "Offer ended";

      function update() {
        var remaining = formatRemaining(end - Date.now());

        if (!remaining) {
          if (label) {
            label.textContent = expired;
          }

          if (value) {
            value.textContent = "";
          }

          return;
        }

        if (label) {
          label.textContent = prefix;
        }

        if (value) {
          value.textContent = remaining;
        }
      }

      update();
      window.setInterval(update, 60000);
    });
  }

  function initCarousel(root) {
    root.querySelectorAll("[data-ssh-carousel]").forEach(function (carousel) {
      if (carousel.dataset.sshCarouselBound === "true") {
        return;
      }

      var track = carousel.querySelector("[data-ssh-track]");
      var slides = Array.prototype.slice.call(carousel.querySelectorAll("[data-ssh-slide]"));
      if (!track || slides.length === 0) {
        return;
      }

      carousel.dataset.sshCarouselBound = "true";

      var dots = Array.prototype.slice.call(carousel.querySelectorAll("[data-ssh-dot]"));
      var prev = carousel.querySelector("[data-ssh-prev]");
      var next = carousel.querySelector("[data-ssh-next]");
      var autoplay = carousel.dataset.autoplay === "true";
      var intervalMs = parseInt(carousel.dataset.interval || "6000", 10);
      var currentIndex = 0;
      var timerId = null;

      function setIndex(index) {
        if (!slides.length) {
          return;
        }

        currentIndex = (index + slides.length) % slides.length;
        track.style.transform = "translateX(-" + currentIndex * 100 + "%)";

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === currentIndex;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });

        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === currentIndex;
          dot.classList.toggle("is-active", isActive);
          dot.setAttribute("aria-current", isActive ? "true" : "false");
        });
      }

      function stopAutoplay() {
        if (timerId) {
          window.clearInterval(timerId);
          timerId = null;
        }
      }

      function startAutoplay() {
        if (!autoplay || slides.length < 2 || intervalMs < 1000) {
          return;
        }

        stopAutoplay();
        timerId = window.setInterval(function () {
          setIndex(currentIndex + 1);
        }, intervalMs);
      }

      if (prev) {
        prev.addEventListener("click", function () {
          setIndex(currentIndex - 1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          setIndex(currentIndex + 1);
          startAutoplay();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          var index = parseInt(dot.dataset.index || "0", 10);
          if (!Number.isNaN(index)) {
            setIndex(index);
            startAutoplay();
          }
        });
      });

      carousel.addEventListener("mouseenter", stopAutoplay);
      carousel.addEventListener("mouseleave", startAutoplay);
      carousel.addEventListener("focusin", stopAutoplay);
      carousel.addEventListener("focusout", function (event) {
        if (!carousel.contains(event.relatedTarget)) {
          startAutoplay();
        }
      });

      setIndex(0);
      startAutoplay();
    });
  }

  function init(scope) {
    var root = scope || document;
    initCountdown(root);
    initCarousel(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
